import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import userAPI from "../../api/UserApi";
import { clearAccessToken } from "../../api/axiosInstance";
import { FiGrid, FiShoppingBag, FiMapPin, FiUser, FiLock, FiLogOut } from "react-icons/fi";

function Sidebar() {
  const navigate = useNavigate();

  const logOut = async () => {
    try {
      await userAPI.logOut();
      clearAccessToken();
      localStorage.removeItem("token");
      localStorage.removeItem("accessToken");
      navigate("/");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="funky-profile-sidebar">
      <div className="profile-nav-links-grid">
        <NavLink
          to="/users/dashboard"
          className={({ isActive }) =>
            `funky-sidebar-link ${isActive ? "active" : ""}`
          }
        >
          <FiGrid className="nav-icon" />
          <span>Dashboard</span>
        </NavLink>

        <NavLink
          to="/users/orders"
          className={({ isActive }) =>
            `funky-sidebar-link ${isActive ? "active" : ""}`
          }
        >
          <FiShoppingBag className="nav-icon" />
          <span>My Orders</span>
        </NavLink>

        <NavLink
          to="/users/addresses"
          className={({ isActive }) =>
            `funky-sidebar-link ${isActive ? "active" : ""}`
          }
        >
          <FiMapPin className="nav-icon" />
          <span>Addresses</span>
        </NavLink>

        <NavLink
          to="/users/account"
          className={({ isActive }) =>
            `funky-sidebar-link ${isActive ? "active" : ""}`
          }
        >
          <FiUser className="nav-icon" />
          <span>Account Details</span>
        </NavLink>

        <NavLink
          to="/users/change-password"
          className={({ isActive }) =>
            `funky-sidebar-link ${isActive ? "active" : ""}`
          }
        >
          <FiLock className="nav-icon" />
          <span>Change Password</span>
        </NavLink>

        <button onClick={logOut} className="funky-sidebar-link logout-btn-link">
          <FiLogOut className="nav-icon text-danger" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
}

export default Sidebar;